import React from 'react';
import ConsentConfirmationModal from '../shared/consent/ConsentConfirmationModal';
import { MODAL_KEYS, ModalKey } from './modalKeys';
import type { ModalFrame, ModalPropsByKey } from './modalTypes';

export type ModalRegistry = {
  [K in ModalKey]: React.ComponentType<ModalPropsByKey[K] & ModalFrame>;
};

/**
 * The component that shows each modal. The provider sits at the app root, so register a large
 * modal with React.lazy(() => import(...)) to keep it out of every page's bundle.
 */
export const MODAL_REGISTRY: ModalRegistry = {
  [MODAL_KEYS.CONSENT_DECLINE]: ConsentConfirmationModal,
  // Admin only, so it loads on first use instead of with every page.
  [MODAL_KEYS.MERGE_CONFIRM]: React.lazy(() => import('../pages/sessionMerge/MergeConfirmModal')),
};
